export const ESTIMATE_SUBMIT_STATUS = {
  STATUS_CANCELLED: 'cancelled',
  STATUS_SUBMITTED: 'submitted',
  STATUS_WAITING_FOR_PROVIDER_SUBMISSION: 'waiting for provider submission'
}